var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8135 0.418154C18.6746 0.648634 19.3514 1.32526 19.5818 2.18627C19.9984 3.7453 20 7.00005 20 7.00005C20 7.00005 20 10.2547 19.5818 11.8137C19.3514 12.6748 18.6746 13.3514 17.8135 13.5818C16.2545 14 10 14 10 14C10 14 3.74547 14 2.18636 13.5818C1.32532 13.3514 0.648664 12.6748 0.418173 11.8137C2.7093e-08 10.2547 0 7.00005 0 7.00005C0 7.00005 2.7093e-08 3.7453 0.418173 2.18627C0.648664 1.32526 1.32532 0.648634 2.18636 0.418154C3.74547 2.70918e-08 10 0 10 0C10 0 16.2545 2.70918e-08 17.8135 0.418154ZM13.194 7.00032L7.99807 9.99982V4.00074L13.194 7.00032Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.c55a7fba2c6480a93a201980122409b6.svg";
export { ForwardRef as ReactComponent };